import { render, staticRenderFns } from "./StudentsRemainingFees.vue?vue&type=template&id=5ca4f6d9&scoped=true&"
import script from "./StudentsRemainingFees.vue?vue&type=script&lang=js&"
export * from "./StudentsRemainingFees.vue?vue&type=script&lang=js&"
import style0 from "./StudentsRemainingFees.vue?vue&type=style&index=0&id=5ca4f6d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca4f6d9",
  null
  
)

export default component.exports